// extracted by mini-css-extract-plugin
module.exports = {"container":"Rating_container__3_T70","star":"Rating_star__2ZZ05","containerError":"Rating_containerError__3q3_n"};